'use client'

import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ResizableDrawerOverlayProps {
  isVisible: boolean
  onClick: () => void
  className?: string
}

/**
 * Semi-transparent overlay with blur effect that appears behind a resizable drawer.
 * Clicking on it triggers the close attempt flow. Supports Escape key.
 */
export const ResizableDrawerOverlay = ({
  isVisible,
  onClick,
  className,
}: ResizableDrawerOverlayProps): ReactNode => {
  if (!isVisible) return null

  return (
    <button
      type="button"
      className={cn(
        'resizable-drawer-overlay',
        'fixed inset-0 z-40',
        'bg-background/60 backdrop-blur-sm',
        'animate-in fade-in duration-200',
        'cursor-default',
        className
      )}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          onClick()
        }
      }}
      tabIndex={-1}
      aria-label="Close drawer"
    />
  )
}

ResizableDrawerOverlay.displayName = 'ResizableDrawerOverlay'
